var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUpgradeicon = function SvgUpgradeicon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12a12 12 0 0 0 12 12Zm0-21.598a9.6 9.6 0 1 1-9.6 9.6 9.6 9.6 0 0 1 9.6-9.6Zm.228 2.4a.924.924 0 0 1 .636.263l3.756 3.756a.6.6 0 0 1 0 .852l-.852.852a.588.588 0 0 1-.84 0L13.2 8.797v9.804a.6.6 0 0 1-.6.6h-1.2a.6.6 0 0 1-.6-.6V8.797l-1.728 1.74a.6.6 0 0 1-.852 0l-.84-.852a.6.6 0 0 1 0-.852l3.756-3.768a.9.9 0 0 1 .636-.264h.456Z",
    clipRule: "evenodd"
  })));
};
export default SvgUpgradeicon;